"use client";
import {
  Row,
  Col,
  Form,
  Input,
  AutoComplete,
  Collapse,
  Select,
  Radio,
  Modal,
  Button,
  message,
  List,
  Grid,
} from "antd";
import styles from "./page.module.scss";
// import "@/src/style/common.css";
import "./tim-nha-khoa.scss";
import Link from "next/link";
import ImageCommon from "@/src/component/image/image";
import iconClose from "@/public/icon/icon-close.svg";
import iconExplain from "@/public/icon/arrow-down-line.svg";
import iconExplainFilter from "@/public/icon/icon-explain-filter.png";
import Image from "next/image";
import React from "react";
import FriendlySelect from "@/src/component/friendly-antd/friendly-select";
import { LDP_LIST } from "@/src/const/variable";
import {
  useEffect,
  useState,
  useRef,
  Suspense,
  useMemo,
  useLayoutEffect,
} from "react";
import * as NProgress from "nprogress";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import moment from "moment";
import { PRICE_FILTER, PRICE_FILTER_SERVICE } from "@/src/const/const";
import {
  removeUndefined,
  wrapperRouterPush,
  strVNForSearch,
  toSlug,
} from "@/src/util/util";
import _ from "lodash";
import SearchResult from "./search-result";
import { getClinicByName } from "@/src/component/home/service";
import { getCategoryIntro } from "./service";
import "@/src/component/home/home.scss";
import MostSearched from "./most-searched";
import { getHeader } from "../phong-kham/[slug]/service-server";

import DirectionsForUseModal from "@/src/component/coupon/directions-for-use";
import {
  PROVINCE,
  PROVINCE_FOR_SELECT,
  PROVINCE_FILLTED_FOR_SELECT,
  SERVICE,
  SERVICE_FILTER,
} from "@/src/const/variable";
import { LIST_WEEKDAY } from "@/src/const/const";
import useWindowSize from "@/src/hooks/useWindowSize";
import bannerNewYear from "../../../public/image/banner-new-year.webp";
import bannerNewYearPC from "../../../public/image/banner-new-year-PC.webp";

const { Search } = Input;
const { Panel } = Collapse;
const FormItem = Form.Item;
const options = {
  enableHighAccuracy: false, // Lower accuracy but faster response
  timeout: 3000, // Timeout after 3 seconds
  maximumAge: 60000, // Use cached location if available within 1 minute
};
const options2 = {
  enableHighAccuracy: false, // Lower accuracy but faster response
  timeout: 10000, // Timeout after 10 seconds
  maximumAge: 60000, // Use cached location if available within 1 minute
};
const { Option } = Select;

function useWindowWidth() {
  const [width, setWidth] = useState(768);

  useEffect(() => {
    if (typeof window === "undefined") return;
    else setWidth(window.innerWidth);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}

const { useBreakpoint } = Grid;

function SearchResultClientChild({ searchParams, searchResult }) {
  const router = useRouter();
  const [form] = Form.useForm();
  const pathname = usePathname();
  const searchParamUrl = useSearchParams();
  const [currentPrice, setCurrentPrice] = useState(PRICE_FILTER);
  const [selectedID, setSelectedID] = useState();
  const windowWidth = useWindowWidth();
  const [activeKey, setActiveKey] = useState();
  const [optionsName, setOptionsName] = useState([]);
  const [showDistrict, setShowDistrict] = useState(false);
  const [listDistrict, setListDistrict] = useState([]);
  const [listWard, setListWard] = useState([]);
  const [changeState, setChangeState] = useState(false);
  const [dataIntroduce, setDataIntroduce] = useState();
  const [inputValue, setInputValue] = useState("");
  const [loadingNearby, setLoadingNearBy] = useState(false);
  const [openFindNearby, setOpenFindNearby] = useState(
    Object.keys(searchParams).length > 0 ? false : true
  );
  const [showDirectionForUse, setShowDirectionForUse] = useState(false);
  useLayoutEffect(() => {
    const scrollElement =
      typeof window !== "undefined"
        ? localStorage.getItem("scroll-element")
        : null;

    if (scrollElement) {
      const element = document.getElementById(scrollElement);
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - 100; // Offset by 50px

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });

        localStorage.removeItem("scroll-element");
      }
    }
  }, [searchParams]);
  useEffect(() => {
    if (windowWidth === null) return;

    if (windowWidth > 768) {
      setActiveKey(["1"]);
    } else {
      setActiveKey([]);
    }
  }, [windowWidth]);
  //parse tag
  let tagSearch = [];
  if (searchParams?.category_service_name) {
    tagSearch.push({
      name: searchParams?.category_service_name,
      key: "category_service",
    });
  }
  if (searchParams?.province_name || searchParams?.district_name) {
    tagSearch.push({
      name: [
        searchParams?.ward_name,
        searchParams?.district_name,
        searchParams?.province_name,
      ]
        .filter(Boolean)
        .join(", "),

      key: "addressName",
      district: searchParams?.district_name ? true : false,
    });
  }
  if (searchParams?.name) {
    tagSearch.push({
      name: searchParams?.name,
      key: "name",
    });
  }
  if (searchParams?.weekday) {
    const weekday = searchParams.weekday.split(",").map(Number);
    weekday.map((item) => {
      tagSearch.push({
        name: item != 8 ? `Thứ ${item}` : "Chủ Nhật",
        key: "weekday",
        value: item,
      });
    });
  }
  if (searchParams?.min || searchParams?.max) {
    if (!searchParams?.max) {
      tagSearch.push({
        name: `Trên ${
          searchParams?.min >= 1
            ? `${searchParams?.min} Triệu`
            : `${searchParams?.min * 1000} Nghìn`
        }`,
        key: "money",
      });
    }
    if (searchParams?.min && searchParams?.max) {
      tagSearch.push({
        name: `${
          searchParams?.min >= 1 ? searchParams?.min : searchParams?.min * 1000
        } đến ${
          searchParams?.max >= 1
            ? `${searchParams?.max} Triệu`
            : `${searchParams?.max * 1000} Nghìn`
        } `,
        key: "money",
      });
    }
    if (!searchParams?.min) {
      tagSearch.push({
        name: `Dưới ${
          searchParams?.max >= 1
            ? `${searchParams?.max} Triệu`
            : `${searchParams?.max * 1000} Nghìn`
        }`,
        key: "money",
      });
    }
  }

  const removeRoute = (item) => {
    if (item?.key == "addressName") {
      form.setFieldsValue({
        province_slug: undefined,
        districtName: undefined,
        wardName: undefined,
      });
    } else if (item?.key == "weekday") {
      const oldWeek = form.getFieldValue("weekday");
      const removedWeek = oldWeek.filter((sitem) => sitem !== item?.value);
      form.setFieldsValue({ weekday: removedWeek });
    } else if (item?.key == "money") {
      form.setFieldsValue({
        min: undefined,
        max: undefined,
      });
    } else {
      form.setFieldsValue({ [item?.key]: undefined });
    }
    onReSearch();
  };

  useEffect(() => {
    (async () => {
      if (searchParams.category_service_name && searchParams.province_slug) {
        const dataIntro = await getCategoryIntro(
          searchParams.category_service_name,
          searchParams.province_id
        );
        setDataIntroduce(dataIntro);
      }
    })();
  }, [searchParams]);

  useEffect(() => {
    if (searchParams.time) {
      form.setFieldsValue({ time: moment(searchParams.time, "HH:mm") });
    }

    if (searchParams.category_service) {
      // const categoryService = searchParams.category_service
      //   .split(",")
      //   .map(Number);
      form.setFieldsValue({
        category_service: parseInt(searchParams.category_service),
      });
    } else {
      form.setFieldsValue({ category_service: undefined });
    }
    // if (searchParams.weekday) {
    //   const weekday = searchParams.weekday.split(",").map(Number);
    //   form.setFieldsValue({ weekday: weekday });
    // }
    // ,
  }, [pathname, searchParamUrl]);

  useEffect(() => {
    const updatedFields = {}; // Chỉ cập nhật 1 lần
    if (searchParams?.province_slug) {
      const itemProvince = PROVINCE_FILLTED_FOR_SELECT.find(
        (item) => item.slug == searchParams.province_slug
      );

      setListDistrict(itemProvince?.district);

      updatedFields.province_slug = itemProvince?.slug;

      // Chỉ cập nhật district nếu khác với giá trị hiện tại
      if (searchParams.district_id) {
        const itemDistrict = itemProvince?.district?.find(
          (item) => item.value == searchParams.district_id
        );

        updatedFields.district_id = itemDistrict?.value;
        updatedFields.districtName = itemDistrict?.label;
        setListWard(itemDistrict?.ward);
        if (searchParams.ward_id) {
          const itemWard = itemDistrict?.ward?.find(
            (item) => item.value == searchParams.ward_id
          );
          updatedFields.ward_id = itemWard?.value;
          updatedFields.wardName = itemWard?.label;
        }
      }
    } else {
      Object.assign(updatedFields, {
        province_slug: undefined,
        district_id: undefined,
        districtName: undefined,
      });
    }

    // Cập nhật min, max, name nếu có
    updatedFields.min = searchParams.min;
    updatedFields.max = searchParams.max;
    if (searchParams?.name && typeof searchParams?.name == "string") {
      updatedFields.name = searchParams.name;
    }

    form.setFieldsValue(updatedFields); // Cập nhật form chỉ 1 lần
    setSelectedID(searchParams.category_service);

    setChangeState((prev) => !prev); // Tránh dependency `changeState`
  }, [pathname, searchParamUrl, searchParams]);

  const onReSearch = async () => {
    const fieldsValue = await form.validateFields();

    const { category_service, province_slug } = fieldsValue;

    const service_slug = SERVICE.find(
      (item) => item.id === category_service
    )?.slug;

    const routeSearch = province_slug ? `/${province_slug}` : "";

    const parseValue = {
      service: service_slug,
      district: toSlug(form.getFieldValue("districtName")),
      ward: toSlug(form.getFieldValue("wardName")),
      ...fieldsValue,
      province_slug: undefined,
      district_id: undefined,
      ward_id: undefined,
      category_service: undefined,
    };

    removeUndefined(parseValue);
    const param = new URLSearchParams(parseValue).toString();

    const urlQuery = `/tim-phong-kham${routeSearch}?${param}`;
    if (pathname == urlQuery && param == searchParamUrl.toString()) {
      NProgress.start();
      NProgress.done();
    } else {
      wrapperRouterPush(router, urlQuery);
    }
    if (openFindNearby) setOpenFindNearby(false);
    return () => {
      clearTimeout(scroll);
    };
  };

  if (typeof window !== "undefined") {
    const fieldLabels = document.querySelectorAll(
      ".ant-form-item-label > label"
    );

    for (let label of fieldLabels) {
      label.addEventListener("click", (event) => {
        event.preventDefault(); // Prevent the default behavior of the click
        console.log("Label click prevented");
      });
    }
  }

  useEffect(() => {
    window.addEventListener("resize", function () {
      var filterContainer = document.getElementById("wpCol");
      if (filterContainer) {
        filterContainer.style.height = window.innerHeight + "px";
      }
    });
  }, []);

  const handleButtonPrice = (item) => {
    form.setFieldsValue({
      min: item.min,
      max: item.max,
    });
  };
  useEffect(() => {
    const filterID = PRICE_FILTER_SERVICE.find((item) => item.id == selectedID);
    if (filterID?.id == null) {
      setCurrentPrice(PRICE_FILTER);
    } else {
      setCurrentPrice(filterID.price);
    }
  }, [selectedID]);

  const fallBack = async () => {
    const headers = await getHeader();
    if (
      !searchParams.province_slug &&
      !(
        headers["cf-iplongitude"] &&
        headers["cf-iplatitude"] &&
        headers["cf-ipcity"] &&
        headers["cf-ipcountry"] == "VN"
      )
    ) {
      form.setFieldsValue({
        province_slug: "ha-noi",
      });
      const listDistrict = PROVINCE_FILLTED_FOR_SELECT.find(
        (item) => item.slug == "ha-noi"
      )?.district;
      setListDistrict(listDistrict);
    }
  };

  useEffect(() => {
    if (!searchParams.lat || !searchParams.lon) {
      fallBack();
    } else {
      fallBack();
    }
  }, [searchParams]);

  const optionsCategoryService = SERVICE_FILTER.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const filterOption = (input, option) => {
    if (option.props.label) {
      return strVNForSearch(option.props.label).includes(strVNForSearch(input));
    } else {
      return false;
    }
  };
  const onSearchName = (searchText) => {
    debounceOnChangeInput(searchText);
  };
  const debounceOnChangeInput = _.debounce((event) => {
    requestSearchName(event);
  }, 300);
  const requestSearchName = async (searchText) => {
    if (searchText) {
      const result = await getClinicByName(searchText);
      const newOption = result.map((item) => {
        return {
          value: item.id,
          label: (
            <Link href={`/phong-kham/${item.slug}`}>
              <div className="item-result-search">
                <ImageCommon data={item} style={"logo-on-search"} />
                {/* <Image src={logos} height={30} width={30}/> */}
                <span>{item.name}</span>
              </div>
            </Link>
          ),
        };
      });
      setOptionsName(newOption);
    }
  };

  const scrollableDivRef = useRef(null);
  const scrollToTop = () => {
    if (scrollableDivRef.current) {
      scrollableDivRef.current.scrollTop = 0;
    }
  };
  const removeAllTag = () => {
    form.resetFields();
    onReSearch();
  };
  useEffect(() => {
    scrollToTop();
  }, [showDistrict]);
  const handleResize = () => setWidth(window.innerWidth);
  const [width, setWidth] = useState(1024);

  useEffect(() => {
    handleResize();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
    }
  }, []);

  const isPathValid = useMemo(() => {
    const regex = /^\/phong-kham$/;
    const result = regex.test(pathname);
    return result;
  }, [pathname]);

  const onSubmitLocation = async () => {
    try {
      NProgress.start();
      setLoadingNearBy(true);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            const hasServiceId = await form.getFieldValue("category_service");
            const categoryService = hasServiceId
              ? SERVICE.find((item) => item.id === hasServiceId)?.name
              : null;
            setOpenFindNearby(false);
            router.push(
              `${pathname}${
                categoryService ? `/${toSlug(categoryService)}` : ""
              }?lat=${latitude}&lon=${longitude}`,
              { scroll: false }
            );
            localStorage.setItem("scroll-element", "element-clinic");
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED) {
              alert(
                "Bạn đã từ chối quyền truy cập vị trí. Để kết quả tìm kiếm chính xác hơn, hãy cấp lại quyền truy cập vị trí trong cài đặt trình duyệt của bạn và thử lại"
              );
            } else {
              message.error("Lấy vị trí thất bại. Vui lòng thử lại.");
            }
            setLoadingNearBy(false);
          },
          options2
        );
      } else {
        setOpenFindNearby(false);
      }
    } catch (error) {
      setLoadingNearBy(false);
      return { message: "An error occurred", error };
    } finally {
      NProgress.done();
    }
  };

  const provinceOptions = PROVINCE_FILLTED_FOR_SELECT.map((province) => {
    return {
      value: province.slug,
      label: province.label,
      district: province.district,
    };
  });
  return (
    <div className="row-wp-search-result">
      {/* <BlockTopFilter searchParams={searchParams} /> */}

      <Form
        form={form}
        className="wrapper-form-search-top"
        onFinish={onReSearch}
      >
        <div id="pin-search"></div>
        <Row
          className={styles.wpBlockTopFilter}
          gutter={[
            { xl: 8, md: 8, xs: 6, sm: 6 },
            { xl: 8, md: 8, xs: 6, sm: 6 },
          ]}
        >
          <Col
            xl={10}
            xs={24}
            sm={24}
            md={24}
            className="wrapper-form-search-address"
          >
            <div className={`${styles.wpItemSearch} wpItemSearch`}>
              <FormItem name="province_slug">
                <FriendlySelect
                  options={provinceOptions}
                  className="province_selection"
                  placeholder="Tỉnh thành"
                  onClear={() => {
                    form.setFieldsValue({
                      district_id: null,
                      districtName: null,
                      ward_id: null,
                      wardName: null,
                    });
                    setListDistrict([]);
                    setListWard([]);
                  }}
                  onChange={(value, option) => {
                    form.setFieldsValue({
                      district_id: null,
                      districtName: null,
                      ward_id: null,
                      wardName: null,
                    });
                    setListDistrict(option?.district);
                    setListWard([]);
                  }}
                  initialValue={form.getFieldValue("province_slug")}
                  dropdownAlign={{
                    points: ["tl", "bl"],
                    offset: [-10, 11],
                  }}
                />
              </FormItem>
            </div>
            <div className={`${styles.wpItemSearch} wpItemSearch`}>
              <FormItem name="district_id">
                <FriendlySelect
                  options={listDistrict}
                  className="province_selection"
                  placeholder="Quận/Huyện"
                  onClear={() => {
                    form.setFieldsValue({
                      district_id: null,
                      districtName: null,
                      ward_id: null,
                      wardName: null,
                    });
                    setListWard([]);
                  }}
                  onChange={(value, option) => {
                    form.setFieldsValue({
                      district_id: option?.value,
                      districtName: option?.label,
                      ward_id: null,
                      wardName: null,
                    });
                    setListWard(option?.ward);
                  }}
                  dropdownAlign={{
                    points: ["tl", "bl"],
                    offset: [-10, 11],
                  }}
                  initialValue={form.getFieldValue("district_id")}
                />
              </FormItem>
            </div>
            <div className={`${styles.wpItemSearch} wpItemSearch`}>
              <FormItem name="ward_id">
                <FriendlySelect
                  options={listWard}
                  className="province_selection"
                  placeholder="Phường/Xã"
                  onClear={() => {
                    form.setFieldsValue({
                      ward_id: null,
                      wardName: null,
                    });
                  }}
                  onChange={(value, option) => {
                    form.setFieldsValue({
                      ward_id: option?.value,
                      wardName: option?.label,
                    });
                  }}
                  dropdownAlign={{
                    points: ["tl", "bl"],
                    offset: [-10, 11],
                  }}
                  initialValue={form.getFieldValue("ward_id")}
                />
              </FormItem>
            </div>
          </Col>
          {/* Phòng khám nha khoa */}
          <Col xl={10} xs={24} sm={24} md={20}>
            <div className={styles.wpItemSearch}>
              {/* <div className={styles.titleSearch}>Phòng khám nha khoa</div> */}
              <FormItem name="name">
                <AutoComplete
                  options={optionsName}
                  placeholder="Nhập tên phòng khám"
                  className="wrapper-input-search"
                  onSearch={onSearchName}
                  value={inputValue}
                  onChange={(data, option) => {
                    form.setFieldsValue({ name: data?.value });
                  }}
                  onSelect={(data, option) => {
                    // setInputValue(option.label);
                    form.setFieldsValue({
                      name: option?.label?.props?.children?.props.children[1]
                        ?.props?.children,
                    });
                  }}
                  labelInValue={true}
                  filterOption={false}
                  onBlur={() => {
                    setOptionsName([]);
                  }}
                  dropdownAlign={{
                    points: ["tl", "bl"], // align dropdown bottom-left to top-left of input element
                    offset: [0, -4], // align offset
                    overflow: {
                      adjustX: 0,
                      adjustY: 0, // do not auto flip in y-axis
                    },
                  }}
                  getPopupContainer={() =>
                    document.getElementById("pin-search")
                  }
                />
              </FormItem>
            </div>
          </Col>
          {/* Button tìm kiếm */}
          <Col xl={4} xs={24} sm={24} md={4} className={styles.colButtonSearch}>
            <div className={styles.wpItemSearch}>
              <Form.Item>
                <Button
                  className={`${styles.buttonSearch} button-blue`}
                  htmlType="submit"
                  style={{ width: "100%", border: "none" }}
                >
                  TÌM KIẾM
                </Button>
              </Form.Item>
            </div>
          </Col>
        </Row>
        {/* most searched */}
        <div
          className={
            isPathValid ? styles.wpMostSearched : styles.wpHideMostSearched
          }
        >
          {isPathValid && <MostSearched />}
        </div>
        {/* temporary hidden banner */}
        {/* <Image
          src={width > 768 ? bannerNewYearPC : bannerNewYear}
          className={styles.bannerPromotionNov}
          alt="banner-promotion-nov"
          loading="lazy"
          onClick={() => setShowDirectionForUse(true)}
        /> */}
        <Row gutter={[{ md: 20, xl: 20 }, 15]} className="wp-filter-row">
          <Col xl={8} xs={24} sm={24} md={9}>
            <div className={`${styles.wpColFilter} wp-filter`} id="wpCol">
              <Collapse
                activeKey={activeKey}
                onChange={setActiveKey}
                expandIcon={({ isActive }) => (
                  <div
                    style={{
                      transform: `rotate(${isActive ? 180 : 0}deg)`,
                      display: "flex",
                      alignItems: "center",
                      padding: "8px",
                      marginRight: 0,
                    }}
                  >
                    <Image
                      src={iconExplain}
                      width={24}
                      height={24}
                      alt="icon"
                    />
                  </div>
                )}
              >
                <Panel header="BỘ LỌC" key="1">
                  <div className={styles.ovflClass}>
                    <div className={styles.wpDistrictFilter}>
                      <div className={styles.criteriaTitle}>Dịch vụ</div>
                      <div className={styles.dash}></div>
                      <FormItem name="category_service">
                        <FriendlySelect
                          options={optionsCategoryService}
                          className="district_selection"
                          placeholder="Chọn dịch vụ"
                          onClear={() => {
                            form.setFieldsValue({
                              category_service: null,
                            });
                          }}
                          onChange={(value, option) => {
                            setSelectedID(value);
                            form.setFieldsValue({
                              category_service: option?.value,
                            });
                          }}
                          initialValue={form.getFieldValue("category_service")}
                          dropdownAlign={{
                            points: ["tl", "bl"],
                            offset: [-15, 3],
                          }}
                        />
                      </FormItem>
                    </div>
                    <div className={styles.wpPriceFilter}>
                      <div className={styles.criteriaTitle}>Giá tiền</div>
                      <div className={styles.dash}></div>
                      <div className={styles.wpInputForm}>
                        <p>Từ</p>
                        <div className={styles.inputForm}>
                          <FormItem name="min">
                            <Input
                              type="number"
                              placeholder="..."
                              className="price-input"
                              inputMode="numeric"
                            />
                          </FormItem>
                        </div>
                        <p>-</p>
                        <div className={styles.inputForm}>
                          <FormItem name="max">
                            <Input
                              type="number"
                              placeholder="..."
                              className="price-input"
                              inputMode="numeric"
                            />
                          </FormItem>
                        </div>
                        <p>Triệu</p>
                      </div>
                      <div className="wp-item-price">
                        <Radio.Group allowClear>
                          <Row gutter={[14, 14]}>
                            {currentPrice.map((item, index) => (
                              <Col span={8} key={index}>
                                <Radio.Button
                                  value={item}
                                  onClick={() => handleButtonPrice(item)}
                                >
                                  {item.name}
                                </Radio.Button>
                              </Col>
                            ))}
                          </Row>
                        </Radio.Group>
                      </div>
                    </div>
                    <div className={styles.wpDayFilter}>
                      <div className={styles.criteriaTitle}>
                        Ngày khám trong tuần
                      </div>
                      <div className={styles.dash}></div>
                      <FormItem name="weekday">
                        <Radio.Group
                          defaultValue={
                            searchParams?.weekday
                              ? parseInt(searchParams?.weekday)
                              : ""
                          }
                        >
                          <Row gutter={[14, 14]}>
                            {LIST_WEEKDAY.map((item, index) => (
                              <Col span={8} key={index}>
                                <Radio.Button
                                  value={item.id}
                                  // onClick={() => form.set('weekday',item.id)}
                                >
                                  {item.name}
                                </Radio.Button>
                              </Col>
                            ))}
                          </Row>
                        </Radio.Group>
                      </FormItem>
                    </div>
                  </div>
                  <div className={styles.wpButtonReSearch}>
                    <div
                      onClick={onReSearch}
                      className={`${styles.buttonReSearch} button-blue`}
                    >
                      ÁP DỤNG
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>
          </Col>
          <Col xl={16} xs={24} sm={24} md={15} className={styles.wpColRight}>
            {tagSearch?.length > 0 && (
              <div className={styles.wpFilter}>
                <div className={styles.titleFilter}>Từ khóa</div>
                <div className={styles.wpTag}>
                  <div className={styles.listTag}>
                    {/* {tagSearch.map((item) => {
                      let hrefTag = "";
                      if (
                        tagSearch.find((newItem) => newItem.district == true)
                      ) {
                        hrefTag = `/phong-kham/${toSlug(
                          searchParams?.province_name
                        )}`;
                        if (
                          tagSearch.find(
                            (newItem) => newItem.key == "category_service"
                          )
                        ) {
                          if (item.key == "addressName") {
                            hrefTag = `/phong-kham/${toSlug(
                              searchParams?.category_service_name
                            )}`;
                          }
                        }
                      } else {
                        if (
                          tagSearch.find(
                            (newItem) => newItem.key == "addressName"
                          ) &&
                          tagSearch.find(
                            (newItem) => newItem.key == "category_service"
                          )
                        ) {
                          if (item.key == "addressName") {
                            hrefTag = `/phong-kham/${toSlug(
                              searchParams?.category_service_name
                            )}`;
                          }
                          if (item.key == "category_service") {
                            hrefTag = `/phong-kham/${toSlug(
                              searchParams?.province_name
                            )}`;
                          }
                        } else if (
                          tagSearch.find(
                            (newItem) => newItem.key == "addressName"
                          )
                        ) {
                          hrefTag = `/phong-kham`;
                        } else if (
                          tagSearch.find(
                            (newItem) => newItem.key == "category_service"
                          )
                        ) {
                          hrefTag = `/phong-kham`;
                        }
                      }
                      return (
                        <div key={item?.name} className={styles.tagSearch}>
                          <a href={hrefTag} className={styles.tagSearchItem}>
                            {item?.name}
                          </a>
                          <Image
                            onClick={() => removeRoute(item)}
                            src={iconClose}
                            className={styles.iconClose}
                            alt="Close icon"
                          />
                        </div>
                      );
                    })} */}
                    <div onClick={removeAllTag} className={styles.tagClear}>
                      Xóa tất cả
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div id="element-clinic">
              <SearchResult
                searchParams={searchParams}
                searchResult={searchResult}
              />
            </div>
          </Col>
        </Row>
        <Row className={styles.wpBlockIntroduceCategoryService}>
          {dataIntroduce?.content && !searchParams.district_id && (
            <div className={styles.wpIntroduce}>
              <div
                className={styles.wpContent}
                dangerouslySetInnerHTML={{ __html: dataIntroduce?.content }}
              />
            </div>
          )}
        </Row>
      </Form>
      {/*Tìm kiếm xung quanh */}
      <Modal
        open={openFindNearby && isPathValid}
        width={752}
        className="wp-find-nearby"
        footer={null}
        centered
        onCancel={() => setOpenFindNearby(false)}
      >
        <>
          <Form form={form} layout="vertical" className="wp-content">
            {/* <FormItem
              className="wp-services"
              name="category_service"
              label={"Bạn đang muốn sử dụng dịch vụ gì về răng miệng?"}
            >
              <FriendlySelect
                options={optionsCategoryService}
                className="chatBoxSelect"
                placeholder="Chọn dịch vụ"
                onChange={(value) => {
                  setSelectedID(value);
                }}
                initialValue={form.getFieldValue("category_service")}
              />
            </FormItem> */}
            <FormItem
              name="province_slug"
              label={"Bạn muốn tìm phòng khám tại khu vực nào?"}
            >
              <FriendlySelect
                options={PROVINCE_FILLTED_FOR_SELECT}
                className="chatBoxSelect"
                placeholder="Chọn khu vực"
                onClear={() => {
                  form.setFieldsValue({
                    province_slug: null,
                    district_id: null,
                    districtName: null,
                  });
                }}
                onChange={(value, option) => {
                  form.setFieldsValue({
                    province_slug: option?.value,
                    district_id: null,
                    districtName: null,
                  });
                  setListDistrict(option?.district);
                }}
                initialValue={form.getFieldValue("province_slug")}
              />
            </FormItem>
            <FormItem className="wp-btn-action">
              <Row style={{ textAlign: "center" }}>
                <Col span={12}>
                  <Button
                    onClick={async () => {
                      await onReSearch();
                      // setTimeout(() => {
                      if (typeof window !== "undefined") {
                        if (
                          form.getFieldsValue().province_slug ||
                          form.getFieldsValue().category_service
                        )
                          localStorage.setItem(
                            "scroll-element",
                            "element-clinic"
                          );
                      }
                      // }, 500);
                      // afterCloseModal();
                    }}
                    className="btn-search"
                    disabled={loadingNearby}
                  >
                    TÌM KIẾM
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    onClick={() => {
                      onSubmitLocation();
                    }}
                    className="btn-find-nearby"
                    loading={loadingNearby}
                  >
                    {!loadingNearby ? "TÌM XUNG QUANH" : ""}
                  </Button>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </>
      </Modal>
      <DirectionsForUseModal
        isModalOpen={showDirectionForUse}
        setIsModalOpen={setShowDirectionForUse}
      />
    </div>
  );
}

export default function SearchResultClient({ searchParams, searchResult }) {
  return (
    <Suspense>
      <SearchResultClientChild
        searchParams={searchParams}
        searchResult={searchResult}
      />
    </Suspense>
  );
}
